import store from '@/store'
import {_} from './util'
import Vue from 'vue'

export default {
	filters: {
		branch_name(bid,arg2,arg3){
          let name = ''
          let branchs = store.getters.getGlobalVar('branchs')
          if(branchs){
            for(let i=0,l=branchs.length;i<l;i++){
              if(bid == branchs[i].bid){
                name = branchs[i].short_name || branchs[i].branch_name
                break
              }
            }
          }
          return name
        },        
        branch_name(bid,empty){
            if(!store.state.maps.branch){
                store.state.maps.branch = {}
                store.state.maps.branch_object = {}
            }
            if(store.state.maps.branch[bid]){
                return store.state.maps.branch[bid]
            }
            let e  = store.state.gvars.branchs.find(item=>item.bid == bid)
            if(e){
                store.state.maps.branch[bid] = e.branch_name
                store.state.maps.branch_object[bid] = e
                return e.branch_name
            }
            return empty||bid
        },
        dpt_name(dpt_id,empty){
            if(!store.state.maps.department){
                store.state.maps.department = {}
                store.state.maps.department_object = {}
            }
            if(store.state.maps.department[dpt_id]){
                return store.state.maps.department[dpt_id]
            }
            let e  = store.state.gvars.departments.find(item=>item.dpt_id == dpt_id)
            if(e){
                store.state.maps.department[dpt_id] = e.dpt_name
                store.state.maps.department_object[dpt_id] = e
                return e.dpt_name
            }
            return empty||dpt_id
        },
        role_name(rid,empty){
            if(!store.state.maps.role){
                store.state.maps.role = {}
                store.state.maps.role_object = {}
            }
            if(store.state.maps.role[rid]){
                return store.state.maps.role[rid]
            }
            let e  = store.state.gvars.roles.find(item=>item.rid == rid)
            if(e){
                store.state.maps.role[rid] = e.role_name
                store.state.maps.role_object[rid] = e
                return e.role_name
            }
            return empty||rid
        },
        ename(eid,empty){
            if(!store.state.maps.employee){
                store.state.maps.employee = {}
                store.state.maps.employee_object = {}
            }
            if(store.state.maps.employee[eid]){
                return store.state.maps.employee[eid]
            }
            let e  = store.state.gvars.employees.find(item=>item.eid == eid)
            if(e){
                store.state.maps.employee[eid] = e.nick_name||e.ename
                store.state.maps.employee_object[eid] = e
                return e.nick_name||e.ename
            }
            return empty||eid
        },
        employee_name(eid,empty){
            if(!store.state.maps.employee){
                store.state.maps.employee = {}
                store.state.maps.employee_object = {}
            }
            if(store.state.maps.employee[eid]){
                return store.state.maps.employee[eid]
            }
            let e  = store.state.gvars.employees.find(item=>item.eid == eid)
            if(e){
                store.state.maps.employee[eid] = e.nick_name||e.ename
                store.state.maps.employee_object[eid] = e
                return e.nick_name||e.ename
            }
            return empty||eid
        },

        lesson_name(lid,empty){
            if(!store.state.maps.lesson){
                store.state.maps.lesson = {}
                store.state.maps.lesson_object = {}
            }
            if(store.state.maps.lesson[lid]){
                return store.state.maps.lesson[lid]
            }
            let e  = store.state.gvars.lessons.find(item=>item.lid == lid)
            if(e){
                store.state.maps.lesson[lid] = e.lesson_name
                store.state.maps.lesson_object[lid] = e
                return e.lesson_name
            }
            return empty||lid
        },
        lesson_no(lid){
            if(!store.state.maps.lesson_object){
                store.state.maps.lesson = {}
                store.state.maps.lesson_object = {}
            }
            if(store.state.maps.lesson_object[lid]){
                return store.state.maps.lesson_object[lid].lesson_no
            }
            let e  = store.state.gvars.lessons.find(item=>item.lid == lid)
            if(e){
                store.state.maps.lesson[lid] = e.lesson_name 
                store.state.maps.lesson_object[lid] = e
                return e.lesson_no
            }
            return ''
        },
        subject_name(sj_id,empty){
            if(!store.state.maps.subject){
                store.state.maps.subject = {}
                store.state.maps.subject_object = {}
            }
            if(store.state.maps.subject[sj_id]){
                return store.state.maps.subject[sj_id]
            }
            let e  = store.state.gvars.subjects.find(item=>item.sj_id == sj_id)
            if(e){
                store.state.maps.subject[sj_id] = e.subject_name
                store.state.maps.subject_object[sj_id] = e
                return e.subject_name
            }
            if(sj_id == 0){
                sj_id = ''
            }
            return empty||sj_id
        },
        classroom_name(cr_id,empty){
			let classrooms = store.state.gvars.classrooms
			if(classrooms) {
				let e  = classrooms.find(item=>item.cr_id == cr_id)
				if(e){
	                return e.room_name
	            }
			}
            return empty||cr_id
        },
        //期段
        season_name(s){
            let seasons = store.state.gvars.dicts.season
            let season  = seasons.find(item=>item.name == s)
            if(season){
                return season.title
            }
            return s
        },
    
        //通用字典翻译
		//调用方式 this.$filter('dict_title')(params.row.sale_role_did,'sale_role')
		//模板调用 {{row.sale_role_did|dict_title('sale_role')}}
		//grade 是使用name作关联要单独处理
        dict_title(v,d,empty){
            let list = store.state.gvars.dicts[d]
            let info
            if(list){
                info = list.find(item=>item.did == v)
                if(d=='grade'){
                    info = list.find(item=>item.name==v)
                }
                if(info){
                    return info.title
                }
            }
            return empty
        }
	},
    methods: {
    	initGlobal(name){
            return new Promise((resolve,reject)=>{
                if(typeof this.$store.state.gvars[name] === 'undefined'){
                    this.$store.dispatch('updateGlobalVar',name).then((data)=>{
                        resolve(data)
                    },(msg)=>{
                        resolve(msg)
                    })
                }else{
                    resolve(this.$store.state.gvars[name])
                }
            })			
		},
		initGoods(name){
			return new Promise((resolve,reject)=>{
				let uri = name
				if(name=='orders_pending'){	uri = 'orders?pay_status=0'}
				if(name=='orders_paied'){ uri = 'orders?pay_status=1' }
                this.$http.get(uri).then(response=>{
                	this.$store.commit('updateGlobalVar',{name:name,data:response.body.data.list})
                	resolve(response)
                }).catch(response=>{
                	reject(response)
                })
			})
		}
    },
    computed:{
    	areas(){
    		return this.$store.getters.getGlobalVar('areas')
    	},
    	branchs(){
    		return this.$store.getters.getGlobalVar('branchs')
    	},
        lesson_config(){
            return this.$store.getters.getGlobalVar('lesson_config')
        },
        //购物车 -- 已选课程 
        carts(){        	
        	return this.$store.getters.getGlobalVar('carts')
        },
        //待支付
        orders_pending(){
        	return this.$store.getters.getGlobalVar('orders_pending')
        },
        //已支付
        orders_paied(){
        	return this.$store.getters.getGlobalVar('orders_paied')
        }
    }
}


// WEBPACK FOOTER //
// ./src/libs/globals.mixin.js